import { stripWorkflowUiState } from "@/lib/campaignWorkflow";

/** Persistable name for unsaved-change comparison. */
export function snapshotCampaignName(name) {
  return String(name ?? "").trim();
}

/**
 * Normalize workflow to the fields we persist — ignore React Flow UI
 * state (selected, dragging, measured size, etc.) so mere selection
 * does not count as unsaved changes.
 */
export function snapshotWorkflow(nodes = [], edges = []) {
  const cleanNodes = stripWorkflowUiState(nodes).map((node) => ({
    id: node.id,
    type: node.type,
    position: node.position,
    data: node.data ?? {},
  }));
  const cleanEdges = (edges || []).map((edge) => ({
    id: edge.id,
    source: edge.source,
    target: edge.target,
    sourceHandle: edge.sourceHandle ?? null,
    targetHandle: edge.targetHandle ?? null,
    type: edge.type ?? null,
  }));
  return JSON.stringify({ nodes: cleanNodes, edges: cleanEdges });
}

export function campaignEditorHasUnsavedChanges({ readOnly, baseline, name, nodes, edges }) {
  if (readOnly || !baseline) return false;
  return (
    snapshotCampaignName(name) !== baseline.name
    || snapshotWorkflow(nodes, edges) !== baseline.workflow
  );
}
